// 保险产品ID
export const HaiNanLeChengInsuPlanId = 'ff808081718236c4017182426a440000'

// 客服链接
export const CustomerServiceLink = 'kefu.html'
export const CustomerServiceLink2 =
  'https://im3f7eb39.7x24cc.com/phone_webChat.html?accountId=N000000034879&chatId=fc5eec3e-a475-4ef3-88e0-c58fb3f5c20c'

// 神策接口
export const register =
  'https://portal.yuanxinbaoxian.com/data-channel-api/sd/dis/receiveSensorsData'

// 百度接口
export const bdBuriedUrl =
  process.env.VUE_APP_BUILD_TARGET === 'prod'
    ? 'https://scrm.yuanxinbaoxian.com'
    : 'https://scrm-test.yuanxinbaoxian.com'
// 理赔报案链接
export const lipie =
  process.env.VUE_APP_BUILD_TARGET === 'prod'
    ? 'https://portal.yuanxinbaoxian.com/mobile-lz/#/'
    : 'http://test.yuanxinbaoxian.com/smcs-mobile-web-lz/customer/#/'

// 直播间链接
export const Livecustomerservice =
  'http://wx.vzan.com/live/tvchat-1102574823?v=637698157679050880'

// 静态资源
export const cdnresources = 'https://static-cdn.yuanxinbaoxian.com'

// 倒计时结束时间
export const CountDownEndDate = '2021/05/10 23:59:59'

// 转盘抽奖
export const TurntableLottery =
  'https://hd.faisco.cn/21994432/PjArAJG9tTVK_WXbPjDkpQ/load.html?style=55&editQrcode=true&_source=1'
